import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        mbrowser: false,
    },
    mutations: {
        mbrowser(state, mbrowser){
            state.mbrowser = mbrowser
        }
    },
    actions: {},
    modules: {},
    getters: {},
    plugins: [
        createPersistedstate({
          storage: window.sessionStorage
        })
    ]
})


// WEBPACK FOOTER //
// ./src/store/index.js